/**
 * @GENERATED from Figma node 3638:51946
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const AutodeskBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#3BA0F3"
      fillRule="evenodd"
      d="m6.284 23.338 5.288-3.945a1.077 1.077 0 0 0-.643-1.939H8.464a.545.545 0 0 1-.513-.731l2.529-6.955a.545.545 0 0 1 1.025 0l4.914 13.514a1.09 1.09 0 0 0 1.025.718h4.224a1.09 1.09 0 0 0 1.025-1.464L14.759.718A1.09 1.09 0 0 0 13.734 0H8.25a1.09 1.09 0 0 0-1.025.717l-5.917 16.23a1.09 1.09 0 0 0 .106.963l3.299 5.142a1.09 1.09 0 0 0 1.57.285z"
      clipRule="evenodd"
    />
    <path
      fill="#00D6B6"
      fillRule="evenodd"
      d="m6.284 23.343 5.291-3.92a1.091 1.091 0 0 0-.65-1.968H1.523a.219.219 0 0 0-.183.336l3.377 5.265a1.09 1.09 0 0 0 1.568.287"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(AutodeskBright);
export { ForwardRef as AutodeskBright };
